import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { FeatureFlag, setFeatureFlag } from 'lib/featureFlags';

type RouteParams = { flag: string };
type Props = RouteComponentProps<RouteParams>;

const FeatureFlagView: FC<Props> = ({ match, location }) => {
  const { flag: raw_flag } = match.params;
  const flag = raw_flag as FeatureFlag;
  const searchParams = new URLSearchParams(location.search);
  const enabled = searchParams.get('enabled') === 'true';
  const label = enabled ? 'enabled' : 'disabled';

  setFeatureFlag(flag, enabled);

  return (
    <div style={{ textAlign: 'center', fontSize: '2rem', paddingTop: '4rem' }}>
      <p>
        Feature flag <strong>{flag}</strong> set to {label}.
      </p>
      <a href="/">home</a>
    </div>
  );
};

export default FeatureFlagView;
